// hooks/useBottomSheet.js
import React, { useState } from "react";
import { saveSharedPost } from "../components/Share";

const ChainIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const SOCIAL_PLATFORMS = [
  {
    key: "whatsapp",
    label: "WhatsApp",
    bg: "bg-[#25D366]/10",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-[#25D366]">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
    ),
    getPostUrl:   (text, url) => `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
    getInviteUrl: (text, url) => `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
  },
  {
    key: "telegram",
    label: "Telegram",
    bg: "bg-[#229ED9]/10",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-[#229ED9]">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    ),
    getPostUrl:   (text, url) => `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    getInviteUrl: (text, url) => `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
  },
  {
    key: "facebook",
    label: "Facebook",
    bg: "bg-[#1877F2]/10",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-[#1877F2]">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    getPostUrl:   (_text, url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    getInviteUrl: (_text, url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    key: "x",
    label: "X",
    bg: "bg-neutral-100 dark:bg-neutral-800",
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-neutral-900 dark:fill-white">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    getPostUrl:   (text, url) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${text} ${url}`)}`,
    getInviteUrl: (text, url) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${text} ${url}`)}`,
  },
];

/* Shared row style for all sheet buttons */
const ROW = "w-full text-left px-4 flex items-center gap-3 hover:bg-neutral-100 dark:hover:bg-neutral-700 active:bg-neutral-200 dark:active:bg-neutral-600 transition-colors touch-manipulation";
const ROW_H = { minHeight: 52 }; // 52px > 44px Apple HIG minimum
export default function useBottomSheet({
  menu,
  setMenu,
  users,
  onRepost,
  myChatId,
  myUserName,          // ✅ NEW
  myDisplayName,       // ✅ NEW
  setQuotePost,
  setShowComposer,
  setIsReplyMode,
  setReplyToPost,
  onDeletePost,
  onEditPost,
  onReportPost,
  followUser,
  unfollowUser,
  appInviteUrl,
}) {
  const [reason, setReason] = useState("");
  const [showReportInput, setShowReportInput] = useState(false);
  const [showUnfollowWarning, setShowUnfollowWarning] = useState(false);
  const [copyToastVisible, setCopyToastVisible] = useState(false);
  const [sharePanel, setSharePanel] = useState(null);

  if (!menu?.open && !showUnfollowWarning) return null;

  const post = menu?.post;
  const isMobile = window.innerWidth <= 768;

  const isRepost       = menu?.type === "repost";
  const isPostAction   = menu?.type === "post-actions";
  const isCommentAction = menu?.type === "comment-actions";
  const isPostReport   = menu?.type === "post-report";
  const isShare        = menu?.type === "share";
  const isComment      = Boolean(post?.commentId);

  const close = () => {
    setReason("");
    setShowReportInput(false);
    setSharePanel(null);
    setMenu({ open: false, post: null, type: null });
  };

  const authorId  = post?.author?.chatId;
  const username  = post?.author?.username || "user";
  const isAuthor  = String(authorId) === String(myChatId);

  const userRecord  = users?.find((u) => String(u.chatId) === String(authorId));
  const isFollowing = Boolean(userRecord?.isFollowing);

  const handleFollowToggle = () => {
    if (!authorId) return;
    if (isFollowing) setShowUnfollowWarning(true);
    else { followUser?.({ targetChatId: authorId }); close(); }
  };

  const handleConfirmUnfollow = () => {
    unfollowUser?.({ targetChatId: authorId });
    setShowUnfollowWarning(false);
    close();
  };

  const handleSubmitReport = () => {
    if (!reason.trim()) return;
    onReportPost?.({ postId: post.postId || null, commentId: post.commentId || null, reason: reason.trim() });
    close();
  };

  const getPostShareUrl = () =>
    typeof window !== "undefined" ? window.location.origin : "";

  const getAppInviteUrl = () =>
    appInviteUrl || (typeof window !== "undefined" ? window.location.origin : "");

  const getPostShareText = () => {
    const snippet = post?.text
      ? ` — "${post.text.slice(0, 80)}${post.text.length > 80 ? "…" : ""}"`
      : "";
    return `@${username} on Metisel${snippet}`;
  };

  const getAppInviteText = () => `Hey! Join me on Metisel — the new social app. Sign up here:`;

  const copyToClipboard = (value) => {
    const finish = () => {
      setCopyToastVisible(true);
      setTimeout(() => setCopyToastVisible(false), 2000);
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(finish);
    } else {
      const el = document.createElement("textarea");
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      finish();
    }
  };

  /* ── SHARE ROOT PANEL ── */
  const ShareRootContent = isShare && !sharePanel && (
    <div className="py-1">
      <button
        onClick={() => copyToClipboard(getPostShareUrl())}
        className={ROW}
        style={ROW_H}
      >
        <span className="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 shrink-0">
          <ChainIcon />
        </span>
        <span className="font-medium text-base">
          {copyToastVisible ? "✓ Copied!" : `Copy ${isComment ? "comment" : "post"} link`}
        </span>
      </button>

      <button
        onClick={() => setSharePanel("share-post")}
        className={ROW}
        style={ROW_H}
      >
        <span className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-500 shrink-0">
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
          </svg>
        </span>
        <span className="font-medium text-base flex-1">
          Share {isComment ? "comment" : "post"} via
        </span>
        <span className="text-neutral-400 text-lg">›</span>
      </button>

      <button
        onClick={() => setSharePanel("invite")}
        className={ROW}
        style={ROW_H}
      >
        <span className="flex items-center justify-center w-9 h-9 rounded-full bg-green-50 dark:bg-green-900/30 shrink-0">
          <svg viewBox="0 0 24 24" className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="19" y1="8" x2="19" y2="14" />
            <line x1="22" y1="11" x2="16" y2="11" />
          </svg>
        </span>
        <span className="font-medium text-base flex-1">Invite friend via</span>
        <span className="text-neutral-400 text-lg">›</span>
      </button>
    </div>
  );

  /* ── SHARE VIA SUB-PANEL ── */
  const SharePostViaContent = isShare && sharePanel === "share-post" && (
    <div className="py-1">
      {SOCIAL_PLATFORMS.map((p) => (
        <button
          key={p.key}
          onClick={async () => {
            await saveSharedPost(post?.postId);
            window.open(p.getPostUrl(getPostShareText(), getPostShareUrl()), "_blank", "noopener");
            close();
          }}
          className={ROW}
          style={ROW_H}
        >
          <span className={`flex items-center justify-center w-9 h-9 rounded-full ${p.bg} shrink-0`}>
            {p.icon}
          </span>
          <span className="font-medium text-base">{p.label}</span>
        </button>
      ))}
    </div>
  );

  /* ── INVITE VIA SUB-PANEL ── */
  const InviteViaContent = isShare && sharePanel === "invite" && (
    <div className="py-1">
      {SOCIAL_PLATFORMS.map((p) => (
        <button
          key={p.key}
          onClick={() => {
            window.open(p.getInviteUrl(getAppInviteText(), getAppInviteUrl()), "_blank", "noopener");
            close();
          }}
          className={ROW}
          style={ROW_H}
        >
          <span className={`flex items-center justify-center w-9 h-9 rounded-full ${p.bg} shrink-0`}>
            {p.icon}
          </span>
          <span className="font-medium text-base">{p.label}</span>
        </button>
      ))}
    </div>
  );

  /* ── FOLLOW BUTTON ── */
  const FollowButton = !isAuthor && !sharePanel && (
    <button className={ROW} style={ROW_H} onClick={handleFollowToggle}>
      <span className="text-base">
        {isFollowing ? `Unfollow @${username}` : `Follow @${username}`}
      </span>
    </button>
  );

  /* ── REPORT SECTION ── */
  const ReportSection = isPostReport && !sharePanel && (
    <>
      {!showReportInput ? (
        <button
          className={`${ROW} text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30`}
          style={ROW_H}
          onClick={() => setShowReportInput(true)}
        >
          🚩 {post?.commentId ? "Report Comment" : "Report Post"}
        </button>
      ) : (
        <div className="px-4 pb-3">
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Reason for reporting..."
            className="w-full border border-neutral-300 dark:border-neutral-600 rounded-xl p-3 mt-2 text-sm bg-white dark:bg-neutral-800 dark:text-neutral-100 resize-none focus:outline-none focus:ring-2 focus:ring-red-400"
            rows={3}
            autoFocus
          />
          <button
            onClick={handleSubmitReport}
            className="mt-2 w-full py-3 rounded-xl bg-red-500 hover:bg-red-600 active:bg-red-700 text-white text-sm font-semibold transition-colors touch-manipulation"
          >
            Submit Report
          </button>
        </div>
      )}
    </>
  );

  /* ── UNFOLLOW WARNING MODAL ── */
  const UnfollowWarningModal = showUnfollowWarning && (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 px-4">
      <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
        <div className="text-xl font-semibold mb-2 text-neutral-900 dark:text-neutral-100">
          Unfollow @{username}?
        </div>
        <div className="text-sm text-neutral-500 dark:text-neutral-400 mb-6 leading-relaxed">
          This action will permanently delete your chat history and all shared media with this user.{" "}
          <span className="text-red-500 font-medium">This cannot be undone.</span>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => setShowUnfollowWarning(false)}
            className="flex-1 py-3 rounded-xl bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-700 dark:hover:bg-neutral-600 font-semibold transition-colors touch-manipulation"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmUnfollow}
            className="flex-1 py-3 rounded-xl bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-semibold transition-colors touch-manipulation"
          >
            Unfollow
          </button>
        </div>
      </div>
    </div>
  );

  /* ── MENU CONTENT ── */
  const MenuContent = (
    <>
      {FollowButton}

      {/* Repost / Quote */}
    {!sharePanel && isRepost && (
  <>
    <button
      onClick={() => {
        onRepost?.({
          postId: post.postId,
          chatId: myChatId,
          originalPost: post,
          authorUsername: myUserName,       // ✅ NEW
          authorDisplayName: myDisplayName, // ✅ NEW
        });
        close();
      }}
      className={ROW}
      style={ROW_H}
    >
      <span className="text-base font-medium">🔁 Repost</span>
    </button>
          <button
            onClick={() => {
              close();
              setQuotePost(post);
              setShowComposer(true);
              setIsReplyMode?.(false);
              setReplyToPost?.(null);
            }}
            className={ROW}
            style={ROW_H}
          >
            <span className="text-base font-medium">✏️ Quote</span>
          </button>
        </>
      )}

      {/* Edit / Delete */}
      {!sharePanel && (isPostAction || isCommentAction) && (
        <>
          <button
            onClick={() => { onEditPost?.(post); close(); }}
            className={ROW}
            style={ROW_H}
          >
            <span className="text-base font-semibold">✏️ Edit {isCommentAction ? "Comment" : "Post"}</span>
          </button>
          <button
            onClick={() => {
              isCommentAction
                ? onDeletePost?.({ commentId: post.commentId })
                : onDeletePost?.({ postId: post.postId });
              close();
            }}
            className={`${ROW} text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30`}
            style={ROW_H}
          >
            <span className="text-base font-semibold">🗑 Delete {isCommentAction ? "Comment" : "Post"}</span>
          </button>
        </>
      )}

      {ReportSection}
      {ShareRootContent}
      {SharePostViaContent}
      {InviteViaContent}
    </>
  );

  const headerLabel = isShare
    ? sharePanel === "share-post"
      ? `Share ${isComment ? "comment" : "post"} via`
      : sharePanel === "invite"
        ? "Invite friend via"
        : `Share ${isComment ? "comment" : "post"} by @${username}`
    : `@${username}`;

  /* ── DESKTOP MODAL ── */
  if (!isMobile) {
    return (
      <>
        {menu?.open && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
            onClick={close}
          >
            <div
              className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="px-4 py-3 border-b border-neutral-200 dark:border-neutral-700 text-sm text-neutral-500 flex items-center gap-2">
                {sharePanel && (
                  <button
                    onClick={() => setSharePanel(null)}
                    className="text-lg text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-300 mr-1 touch-manipulation"
                    style={{ minWidth: 32, minHeight: 32 }}
                  >
                    ‹
                  </button>
                )}
                {headerLabel}
              </div>
              <div>{MenuContent}</div>
              {!sharePanel && (
                <div className="border-t border-neutral-200 dark:border-neutral-700">
                  <button
                    onClick={close}
                    className="w-full px-4 py-3 text-center text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-700 font-medium touch-manipulation"
                    style={ROW_H}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {UnfollowWarningModal}
      </>
    );
  }

  /* ── MOBILE BOTTOM SHEET ── */
  return (
    <>
      {menu?.open && (
        <>
          <div className="fixed inset-0 z-[65] bg-black/40" onClick={close} />
          <div
            className="fixed bottom-0 left-0 right-0 z-[70] bg-white dark:bg-neutral-900 rounded-t-2xl shadow-2xl border-t border-neutral-200 dark:border-neutral-700"
          >
            {/* Drag handle */}
            <div className="flex justify-center py-2.5">
              <div className="w-10 h-1 rounded-full bg-neutral-300 dark:bg-neutral-700" />
            </div>

            {/* Header */}
            <div className="px-4 pb-2 text-sm text-neutral-500 dark:text-neutral-400 flex items-center gap-2">
              {sharePanel && (
                <button
                  onClick={() => setSharePanel(null)}
                  className="text-lg text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-300 mr-1 touch-manipulation"
                  style={{ minWidth: 32, minHeight: 32 }}
                >
                  ‹
                </button>
              )}
              {headerLabel}
            </div>

            {MenuContent}

            {!sharePanel && (
              <div className="border-t border-neutral-200 dark:border-neutral-700 mt-1">
                <button
                  onClick={close}
                  className="w-full px-4 py-3 text-center text-neutral-500 dark:text-neutral-400 font-medium touch-manipulation"
                  style={ROW_H}
                >
                  Cancel
                </button>
              </div>
            )}

            {/* iOS home indicator safe area */}
            <div
              style={{ height: "env(safe-area-inset-bottom, 16px)" }}
              aria-hidden="true"
            />
          </div>
        </>
      )}
      {UnfollowWarningModal}
    </>
  );
}